import { useMemo } from 'react';
import { defaultTo, includes } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import useFormFieldValue from '@gef-ui/form-core/hooks/state/useFormFieldValue';
import { getMessage } from '@gef-ui/localization/messages';

import { EMPTY_VALUES } from 'constants/general';
import { EVENT, EVENT_TYPE } from 'features/common/gtm/constants';
import { useDataLayer } from 'features/common/gtm/hooks';

import { productDomainsSelectAllOption } from './constants';

export const useClickChartDataLayer = () => {
	const handleDataLayer = useDataLayer({ event: EVENT.clickChart, eventType: EVENT_TYPE.clickType });
	return handleDataLayer;
};

export const useClickTableDataLayer = () => {
	const handleDataLayer = useDataLayer({ event: EVENT.clickTable, eventType: EVENT_TYPE.clickType });
	return handleDataLayer;
};

export const useFilteredProductDomainsOptionsByField = (field, options) => {
	const selectedOptionsFromField = defaultTo(EMPTY_VALUES.ARRAY, useFormFieldValue({ fieldName: field }));

	return useMemo(() => {
		if (!isNilOrEmpty(options)) {
			const optionsWithSelectAll = [
				{
					...productDomainsSelectAllOption,
					description: getMessage(productDomainsSelectAllOption.description),
				},
				...options,
			];
			return optionsWithSelectAll.filter((option) => !includes(option?.id, selectedOptionsFromField));
		} else {
			return EMPTY_VALUES.ARRAY;
		}
	}, [options, selectedOptionsFromField]);
};
